import { Text } from 'blaze-ui/Text/Text'
import { ChatComparisonResolvedContent, ChatMessage } from 'api/clients/ChatClient'
import Styles from './ComparisonResolvedContent.module.scss'
import { Check02 } from 'blaze-ui/icons/16'
import { formatMessageTime } from '../../Message'

interface ComparisonResolvedContentProps {
  content: ChatComparisonResolvedContent
  message: ChatMessage
}

export const ComparisonResolvedContent = ({ content, message }: ComparisonResolvedContentProps) => {
  const label = content.action === 'accepted' ? 'Selected modified version' : 'Kept original version'

  return (
    <div className={Styles.root}>
      <div className={Styles.bubble}>
        <div className={Styles.iconContainer}>
          <Check02 color="var(--light-100)" size={11} />
        </div>
        <Text color="var(--dark-90)">{label}</Text>
      </div>
      <Text variant="metadata" color="var(--dark-40)">
        {formatMessageTime(message.created_at)}
      </Text>
    </div>
  )
}
